// Parity with the Docs::PdfPageTemplate enum is enforced by spec/models/docs/pdf_page_template_spec.rb.
export const Orientation = {
  Unknown: 'unknown',
  Portrait: 'portrait',
  Landscape: 'landscape',
  Square: 'square',
  Mixed: 'mixed',
} as const;

export type Orientation = (typeof Orientation)[keyof typeof Orientation];

export interface PageUsage {
  documentTemplateId: number;
  documentTemplateName: string;
  contextType: string;
  contextId: number;
  contextName: string | null;
  inPageLibrary: boolean;
  inDefaultPages: boolean;
  position: number | null;
  lastPage: boolean;
}

export interface PageRecord {
  id: number;
  templateType: string;
  name: string;
  userLabel: string | null;
  createdByName: string | null;
  sizeLabel: string | null;
  orientation: Orientation;
  createdAt: string | null;
  updatedAt: string | null;
  documentsCount: number;
  documents: PageUsage[];
}

export interface FilterOption {
  value: string;
  label: string;
}

export interface DocumentFilterOption {
  value: number;
  label: string;
}

export interface FilterOptions {
  pageTypes: FilterOption[];
  orientations: FilterOption[];
  createdBy: FilterOption[];
  documents: DocumentFilterOption[];
}

export type UsageFilter = 'used' | 'not_used' | null;

export type SortDirection = 'asc' | 'desc';

export interface SortState {
  name: string;
  direction: SortDirection;
}

export interface ColumnConfig {
  key: string;
  label: string;
  sortKey?: string;
}
